module.exports = __webpack_public_path__ + "static/media/4.f4dd6d48.jpg";